<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Transactions</h5>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1">
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <div class="p-3">
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      id="fieldset-1"
                      label="Date Created"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-row>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="created_at_start"
                                :format="customFormatter"
                                :disabledDates="disabledCreatedDatesStart"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateCreatedStart"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="created_at_end"
                                :format="customFormatter"
                                :disabledDates="disabledCreatedDatesEnd"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateCreatedEnd"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      id="fieldset-1"
                      label="Paid Date"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-row>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="paid_at_start"
                                :format="customFormatter"
                                :disabledDates="disabledPaidDatesStart"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDatePaidStart"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="paid_at_end"
                                :format="customFormatter"
                                :disabledDates="disabledPaidDatesEnd"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDatePaidEnd"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
                <br />
                <b-row style="text-align-last: right">
                  <b-col>
                    <b-button
                      variant="outline-secondary"
                      @click="resetSearch()"
                      class="mr-3"
                      >Set Ulang</b-button
                    >
                    <b-button variant="primary" @click="search()"
                      >Cari</b-button
                    >
                  </b-col>
                </b-row>
              </div>
              <b-dropdown-item
                class="pointer-off"
                style="width: 450px"
              ></b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col md="1" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <download-csv
            class="d-none"
            :data="CSV"
            name="ppob_transaction.csv"
            ref="DownloadCSV"
          ></download-csv>
          <b-button
            class="btn btn-primary"
            :disabled="loadingCSV"
            @click="downloadCSV()"
          >
            <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner>
            <i class="fas fa-file-download" style="font-size: 16px"></i> &nbsp;
            Export to CSV
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="ppobTransaction"
        :items="getInfo"
        :fields="transactions"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(amount)="{ item }">
          <span>
            {{item.amount | rupiah}}
          </span>
        </template>
        <template v-slot:cell(ppob_type)="{ item }">
          <span class="text-capitalize">
            {{ item.product_type | remove_underscore }} - {{ item.bill_type | remove_underscore }}
          </span>
        </template>
        <template v-slot:cell(adjustment_amount)="{ item }">
          <span v-if="item.adjustment_type == 'percentage'">
            {{item.adjustment_amount | percentage_symbol}}
          </span>
          <span v-else>
            {{item.adjustment_amount | rupiah}}
          </span>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: true,
      loadingCSV: false,
      errored: false,
      items: [],
      detail: {},
      modalShow: false,
      transactions: [
        {
          key: "created_at",
          label: "Date Created",
          sortable: false,
          class: "text-left"
        },
        {
          key: "paid_at",
          label: "Paid Date",
          sortable: false,
          class: "text-left"
        },
        {
          key: "product_name",
          label: "Product Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "ref_number",
          label: "Ref Number",
          sortable: false,
          class: "text-left"
        },
        {
          key: "invoice_number",
          label: "Invoice Number",
          sortable: false,
          class: "text-left"
        },
        {
          key: "amount",
          label: "Amount",
          sortable: false,
          class: "text-left"
        },
        {
          key: "payment_method",
          label: "Payment Method",
          sortable: false,
          class: "text-left"
        },
        {
          key: "ppob_type",
          label: "PPOB Type",
          sortable: false,
          class: "text-left"
        },
        {
          key: "brand_name",
          label: "Brand Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "provider_gateway",
          label: "PPOB Gateway",
          sortable: false,
          class: "text-left"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-left"
        },
        {
          key: "adjustment_type",
          label: "Type of Adjustment",
          sortable: false,
          class: "text-left"
        },
        {
          key: "adjustment_amount",
          label: "Adjustment Amount",
          sortable: false,
          class: "text-left"
        },
        {
          key: "adjustment_as",
          label: "Adjustment As",
          sortable: false,
          class: "text-left"
        }
      ],
      fromPage: [],
      toPage: [],
      CSV: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      created_at_start: new Date(Date.now() - (7 * 24 * 60 * 60 * 1000)),
      created_at_end: new Date(Date.now()),
      paid_at_start: "",
      paid_at_end: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
    disabledCreatedDatesStart() {
      var disabledDates = {
        from: new Date(this.created_at_end + 8640000),
      };
      return disabledDates;
    },
    disabledCreatedDatesEnd() {
      var disabledDates = {
        to: new Date(this.created_at_start - 8640000),
      };
      return disabledDates;
    },
    disabledPaidDatesStart() {
      var disabledDates = {
        from: new Date(this.paid_at_end + 8640000),
      };
      return disabledDates;
    },
    disabledPaidDatesEnd() {
      var disabledDates = {
        to: new Date(this.paid_at_start - 8640000),
      };
      return disabledDates;
    },
  },
  methods: {
    search() {
      this.$refs.ppobTransaction.refresh();
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetDateCreatedStart() {
      this.created_at_start = "";
    },
    resetDateCreatedEnd() {
      this.created_at_end = "";
    },
    resetDatePaidStart() {
      this.paid_at_start = "";
    },
    resetDatePaidEnd() {
      this.paid_at_end = "";
    },
    resetSearch() {
      this.$refs.ppobTransaction.refresh();
      this.created_at_start = "";
      this.created_at_end = "";
      this.paid_at_start = "";
      this.paid_at_end = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      formData.append(
        "created_at_start",
        this.created_at_start != ""
          ? moment(this.created_at_start).format(`YYYY-MM-DD`)
          : ""
      );
      formData.append(
        "created_at_end",
        this.created_at_end != ""
          ? moment(this.created_at_end).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "paid_at_start",
        this.paid_at_start != ""
          ? moment(this.paid_at_start).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "paid_at_end",
        this.paid_at_end != ""
          ? moment(this.paid_at_end).format("YYYY-MM-DD")
          : ""
      );
      this.$store
        .dispatch("PPOBTransactionModule/getPPOBTransactionWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
            const formData = new FormData();
            const ctx = this.$refs.ppobTransaction;
            formData.append("search_param", ctx.filter);
            formData.append("limit", ctx.perPage);
            formData.append("page", ctx.currentPage);
            formData.append("sort_by", ctx.sortBy);
            formData.append("is_sort_asc", false);
            formData.append(
              "created_at_start",
              this.created_at_start != ""
                ? moment(this.created_at_start).format(`YYYY-MM-DD`)
                : ""
            );
            formData.append(
              "created_at_end",
              this.created_at_end != ""
                ? moment(this.created_at_end).format("YYYY-MM-DD")
                : ""
            );
            formData.append(
              "paid_at_start",
              this.paid_at_start != ""
                ? moment(this.paid_at_start).format("YYYY-MM-DD")
                : ""
            );
            formData.append(
              "paid_at_end",
              this.paid_at_end != ""
                ? moment(this.paid_at_end).format("YYYY-MM-DD")
                : ""
            );
            this.$store
              .dispatch("PPOBTransactionModule/getPPOBTransactionExport", formData)
              .then((response) => {
                this.CSV = response.data.data || [];
                if (this.CSV.length === 0) {
                  this.$swal({
                    title: "CSV Report",
                    text: "Tidak ada data yang bisa di generate",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Ya!",
                  })
                  this.loadingCSV = false;
                } else {
                  setTimeout(() => {
                    this.loadingCSV = false;
                    this.$refs.DownloadCSV.$el.click();
                  }, 1000);
                }
              })
              .catch((error) => {
                this.loadingCSV = false;
              });
        } else {
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>